import React, { useEffect, useState } from "react";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Text,
  VStack,
} from "@chakra-ui/react";
import { SUPPLIER_STATUS_CONFIG, SUPPLIER_STATUS_OPTIONS } from "../suppliersMock";

// Change a supplier's lifecycle status (Pending / Active / Inactive /
// Archived). Pre-selects the current status; onSave receives the new value.
function ChangeStatusModal({ isOpen, onClose, onSave, supplier }) {
  const [status, setStatus] = useState(supplier?.status);

  useEffect(() => {
    if (isOpen) setStatus(supplier?.status);
  }, [isOpen, supplier]);

  const handleSubmit = () => {
    onSave(status);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="darkTeal" fontWeight="700">Change status</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {supplier && (
            <Text fontSize="13px" color="gray.500" mb={4}>
              {supplier.name}
            </Text>
          )}
          <RadioGroup value={status} onChange={setStatus}>
            <VStack align="stretch" spacing={2}>
              {SUPPLIER_STATUS_OPTIONS.map((opt) => {
                const cfg = SUPPLIER_STATUS_CONFIG[opt.value];
                const selected = status === opt.value;
                return (
                  <Flex
                    key={opt.value}
                    align="center"
                    gap={3}
                    p={3}
                    borderWidth="1px"
                    borderColor={selected ? "lime" : "gray.200"}
                    bg={selected ? "lightLime" : "white"}
                    borderRadius="md"
                    cursor="pointer"
                    onClick={() => setStatus(opt.value)}
                    _hover={{ borderColor: "lime" }}
                  >
                    <Radio value={opt.value} colorScheme="limeShade" />
                    <Flex align="center" gap={2}>
                      <Text w="8px" h="8px" borderRadius="full" bg={cfg.bg} />
                      <Text fontSize="14px" color="gray.700" fontWeight="500">{cfg.label}</Text>
                    </Flex>
                  </Flex>
                );
              })}
            </VStack>
          </RadioGroup>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="secondary" borderRadius="full" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button bg="limeShade.600" color="white" borderRadius="full" _hover={{ bg: "limeShade.700" }} size="sm" isDisabled={!status} onClick={handleSubmit}>
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default ChangeStatusModal;
